/**
 * @file index.js
 * @author dingzhenyue
 * @desc 角色设置
 */

import bendsdk from '@baidu/bend-plugin-sdk';

const routes = [
    {
        path: '/roleSet',
        name: 'roleSet',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class roleSet extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}